/**
 * Youna Orange Theme Preset
 *
 * Youna project branding: warm-orange base styling plus the YOUNA
 * disclaimer/consent copy. This file is the single home of Youna-specific
 * strings in the widget — it must only be bundled by entries that ship the
 * Youna theme (npm lib, legacy embed, variants/youna).
 */
import { ThemePreset } from '../../components/Widget/ThemeContext';
import { baseWarmOrangeTheme } from './base-warm-orange';

export const younaOrangeTheme: ThemePreset = {
    ...baseWarmOrangeTheme,

    themeName: 'youna-orange',

    // Disclaimer text below input
    disclaimer: {
        enabled: true,
        fontSize: '10px',
        text: 'YOUNA kann Fehler machen und ersetzt keine Therapeut*in, Freund*in oder Beratungsstelle .',
    },

    // Consent overlay configuration
    consent: {
        enabled: true,
        buttonText: 'Ich willige ein',
        buttonColor: '#FF5229',
        privacyLinkUrl: '#',
        privacyLinkText: 'Datenschutzhinweisen',
        storageKey: 'youna_consent_accepted',
    },
};

export type { ThemePreset } from '../../components/Widget/ThemeContext';
